import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import VendorCardList from '../atoms/vendor-card/VendorCardList'
import styles from './venderListStyle.module.scss'

const VenderListView = ({type}) => {
	const vendors = useSelector((s) => s.vendor.vendorSearchList)
	return (
		<div className={styles.venderListView}>
			<Grid container spacing={2}>
				{vendors?.length > 0 &&
					vendors.map((item) => (
						<Grid size={{ xs: 12 }} key={item._id}>
							<VendorCardList data={item} type={type}/>
						</Grid>
					))}
			</Grid>
		</div>
	)
}

export default VenderListView
